import { Injectable } from '@angular/core';
import {
  ActivatedRoute,
  ActivatedRouteSnapshot,
  Resolve,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthAdminService } from 'src/app/core/auth/service/auth-admin.service';

@Injectable()
export class ForgotPasswordTokenResolverGuard implements Resolve<any> {
  constructor(
    private service: AuthAdminService,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> {
    if (route.params && route.params.token) {
      return this.service.forgotPasswordVerifyToken(route.params.token).pipe(
        catchError(() => {
          this.router.navigate([
            '/' +
              route.parent?.params.companyToken +
              '/auth/forgot-password-invalid-token',
          ]);
          return this.clearUser();
        })
      );
    } else {
      return this.clearUser();
    }
  }

  clearUser() {
    return of({});
  }
}
